import React from 'react';
import { TableHead } from '@mui/material';
export default function Head(_a) {
    var children = _a.children;
    return (React.createElement(TableHead, null, children));
}
